import { defBaseUnit, defCustomUnit } from '../registry';

export const storageUnits = [
  defBaseUnit('bit-hour'), //base unit for cloud-storage

  defCustomUnit('byte-second', 'byte-second', 'bit-hour', 1 / 450), //  1 [byte*second] * 8 [bit/byte] * 1/3600 [hour/second]
  defCustomUnit('gigabyte-hour', 'gigabyte-hour', 'bit-hour', 8e9),
  defCustomUnit('gigabyte-month', 'gigabyte-month', 'bit-hour', 5.84e12), //1 [gigabyte-month] * [8*10^9 bit/gigabyte] * [730 hours/month]
  defCustomUnit('terabyte-hour', 'terabyte-hour', 'bit-hour', 8e12),
  defCustomUnit('terabyte-month', 'terabyte-month', 'bit-hour', 5.84e15), //1 [terabyte-month] * [8*10^12 bit/terabyte] * [730 hours/month]
];

// NOT defining any aliases for now, because they are dangerously ambiguous.
